import { Configure } from 'react-instantsearch-hooks-web';
import { HIT_FIELDS, SnippetType, SnippetTypeObject } from './Hits/_types';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { defaultFilter } from './util';

const attributesToHighlight: HIT_FIELDS[] = [
  'pageTitle',
  'body',
  'firstName',
  'lastName',
  'author',

  // 'department',
  // 'eventCategory',
  // 'manager',
  // 'email',
];

const attributesToSnippet: SnippetType[] = [
  { field: 'body', maxWords: 40 },
  { field: 'description', maxWords: 40 },
];

const mappedSnippets = attributesToSnippet.map((x: HIT_FIELDS | SnippetTypeObject): string => {
  const obj = x as SnippetTypeObject;
  if (obj.field && obj.maxWords) {
    return `${obj.field}:${obj.maxWords}`;
  }
  if (obj.field && obj.maxWords) {
    return obj.field;
  }
  return x as HIT_FIELDS;
});

const filter = defaultFilter();
const AlgoliaConfigure = () => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;

  return pageEditing ? (
    <></>
  ) : (
    <Configure
      attributesToHighlight={attributesToHighlight}
      attributesToSnippet={mappedSnippets}
      filters={filter}
      hitsPerPage={10}
    />
  );
};

export default AlgoliaConfigure;
